[
  {
    "code": "ML-BKO",
    "name": "Bamako"
  },
  {
    "code": "ML-7",
    "name": "Gao"
  },
  {
    "code": "ML-1",
    "name": "Kayes"
  },
  {
    "code": "ML-8",
    "name": "Kidal"
  },
  {
    "code": "ML-2",
    "name": "Koulikoro"
  },
  {
    "code": "ML-5",
    "name": "Mopti"
  },
  {
    "code": "ML-3",
    "name": "Sikasso"
  },
  {
    "code": "ML-4",
    "name": "Ségou"
  },
  {
    "code": "ML-6",
    "name": "Tombouctou"
  }
]